import BaseEntity from '../../base/BaseEntity.model';
import Persona, { MedidaTiempoEmbarazo } from '@/models/persona/persona.model';
import SolicitudCambioComposicionFamiliarDocumento from './documento.model';

export default class SolicitudCambioComposicionFamiliarCorreccion extends BaseEntity {
    public solicitudCambioComposicionFamiliarId?: number;
    public centroAcademicoId?: number;
    public codHogar?: string;
    public codHogarSiuben?: string;
    public parentescoId?: number;
    public parentescoNombre?: string;
    public documentos?: SolicitudCambioComposicionFamiliarDocumento[];
    public cedula?: string;
    public nombre1?: string;
    public nombre2?: string;
    public apellido1?: string;
    public apellido2?: string;
    public sexo?: 'M' | 'F';
    public estadoCivil?: string;
    public foto?: string;
    public fechaNacimiento?: Date | string;
    public noActNacimiento?: string;
    public miembroSiubenId?: number;
    public cursoEstudiante?: string;
    public discapacitado?: boolean;
    public incapacitado?: boolean;
    public lee?: boolean;
    public escribe?: boolean;
    public embarazada?: boolean;
    public tiempoEmbarazo?: number;
    public medidaTiempoEmbarazo?: MedidaTiempoEmbarazo;
    public nombreCompleto?: string;
    public edad?: number;
    public edadText?: string;
    public persona?: any;
    public cedulaPadre?: string;
    public cedulaMadre?: string;
    public telefono?: string;
    constructor(public hogarId: number | undefined = undefined, public miembroId: number | undefined = undefined, public personaId: number | undefined = undefined) {
        super();
        this.solicitudCambioComposicionFamiliarId = undefined;
        this.codHogar = undefined;
        this.parentescoNombre = undefined;
        this.parentescoId = undefined;
        this.cedulaPadre = undefined;
        this.cedulaMadre = undefined;
        this.telefono = undefined;
        this.documentos = [];
        this.id = undefined;
        this.cedula = undefined;
        this.nombre1 = undefined;
        this.nombre2 = undefined;
        this.apellido1 = undefined;
        this.apellido2 = undefined;
        this.sexo = undefined;
        this.estadoCivil = undefined;
        this.foto = undefined;
        this.fechaNacimiento = undefined;
        this.noActNacimiento = undefined;
        this.centroAcademicoId = undefined;
        this.cursoEstudiante = undefined;
        this.discapacitado = undefined;
        this.incapacitado = undefined;
        this.lee = undefined;
        this.escribe = undefined;
        this.embarazada = undefined;
        this.tiempoEmbarazo = undefined;
        this.medidaTiempoEmbarazo = 0;
        this.nombreCompleto = undefined;
        this.edad = undefined;
        this.edadText = undefined;
    }
}

